module.exports = __webpack_public_path__ + "static/img/banner.a802ad2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/设备及原料/生物试剂/banner.png
// module id = Nu9y
// module chunks = 16